/* eslint-disable react/prop-types */
import React from "react";
import { BiHealth } from "react-icons/bi";

export const IconRequiredSvg = ({ color = "#DD4558", ...props }) => {
	return <BiHealth size={8} fill={color} {...props} />;
};
